import React from 'react';
import styles from '../styles/components/Progress.module.css';

export interface ProgressData {
  percentage: number;
  fullWidth?: boolean;
}

const Progress: React.FC<ProgressData> = ({
  percentage,
  fullWidth = false,
}) => {
  return (
    <div
      className={[styles.progress, fullWidth ? styles.fullWidth : ''].join(' ')}
    >
      <div className={styles.progressBar} style={{ width: `${percentage}%` }} />

      <div className={styles.progressTitle}>
        <b>PROGRESS : </b> {percentage}% COMPLETED
      </div>
    </div>
  );
};

export default Progress;
